<template>
    <div class="card-scene" style="overflow-x: auto; background: #99a; position: relative; height: 100%; margin-top: 46px;">

        <Container
                group-name="section"
                orientation="horizontal"
                @drop="onColumnDrop( $event )"
                drag-handle-selector=".card-column-header"
                @drag-start="dragStart"
                :drop-placeholder="dropPlaceholderOptions"
                :get-child-payload="getSectionPayload"
                :should-accept-drop="( src, payload ) => sectionDropControl( src, payload )"
                style="display: flex;"
        >
            <Draggable v-for="section in sections" :key="section.id">

                <div :class="[ sectionOptions.className, getColor( section ) ]" style="position: relative; height: 100%;">
                    <div class="card-column-header">

                        <v-layout row>
                            <v-flex xs9>
                                <d-section-mini-editor
                                    v-if="sectionId == section.id"
                                    :key="section.id"
                                    :name="section.name"
                                    @ok="( name ) => { section.name = name; onChangeSection( section ); }"
                                    mb-2
                                ></d-section-mini-editor>
                                <v-layout row v-else>
                            <span
                                    style="padding-top: 20px;"
                                    :key="section.id"
                                    @click="sectionNameMode( section.id )"
                            >{{ section.name }}</span>
                                </v-layout>
                            </v-flex>
                            <v-flex xs3 style="text-align: right; padding-top: 10px;">

                                <v-menu v-if="isEditMode() && isUserSection( section )" class="right">
                                    <v-btn small icon slot="activator">
                                        <v-icon class="mx-0">more_horiz</v-icon>
                                    </v-btn>
                                    <v-list dense>
                                        <template v-for="(item, index) in sectionMenu">
                                            <v-list-tile v-if="item.title" :key="index" @click="sectionMenuHandler( item.action, section.id )">
                                                <v-icon class="mr-3">{{ item.icon }}</v-icon>
                                                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                            </v-list-tile>
                                            <v-divider v-else-if="item.divider" :key="index"></v-divider>
                                        </template>
                                    </v-list>
                                </v-menu>

                            </v-flex>
                        </v-layout>

                    </div>
                    <Container
                            group-name="card"
                            @drop="(e) => onCardDrop( section.id, e )"
                            @drag-start="(e) => {}"
                            :get-child-payload="getCardPayload( section.id )"
                            :should-accept-drop="( src, payload ) => cardDropControl( src, payload, section )"
                            drag-class="card-ghost"
                            drop-class="card-ghost-drop"
                            :drop-placeholder="upperDropPlaceholderOptions"
                            style="overflow-y: auto;"
                            :style="{ height: ( newCard == section.id ) ? 'calc(100% - 174px)' : 'calc(100% - 95px)' }"
                    >
                        <Draggable v-for="card in section.cards" :key="card.id">

                            <div :class="cardOptions.className" :style="getColorByProcessType( card )" @click="$emit( 'openCard', card )">
                                <v-layout row>
                                    <div>
                                        <v-flex xs12>{{ card.process.name ? card.process.name : card.name }}</v-flex>
                                        <v-flex xs12 class="mb-2 mt-1" style="color: #907fa5;">#{{ card.process.tag }}</v-flex>
                                    </div>
                                    <v-spacer></v-spacer>
                                    <v-menu class="right">
                                        <template v-slot:activator="{ on }">
                                            <v-btn small icon style="margin: 0;" @click.stop="on.click">
                                                <v-icon class="mx-0" color="blue-grey lighten-4">more_vert</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list dense>
                                            <template v-for="(item, index) in cardMenu">
                                                <v-list-tile v-if="item.title && item.access( card )" :key="index" @click="cardMenuHandler( item.action, section.id, card )">
                                                    <v-icon class="mr-3">{{ item.icon }}</v-icon>
                                                    <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                                                </v-list-tile>
                                                <v-divider v-else-if="item.divider" :key="index"></v-divider>
                                            </template>
                                        </v-list>
                                    </v-menu>
                                </v-layout>
                                <v-layout row>
                                    <div class="card-status" :class="getStatusClass( card )" :title="getStatusTooltip( card )">
                                        <v-icon class="ma-0">{{ getCardIcon( card ) }}</v-icon>
                                    </div>
                                    <v-spacer></v-spacer>
                                    <v-avatar v-if="getCustomerAvatar( card )" size="28px" :title="getCustomerName( card )">
                                        <img v-if="true" :src="getCustomerAvatar( card )"/>
                                    </v-avatar>
                                    <v-icon v-else style="color: #907fa5;" :title="getCustomerName( card )">mdi-account-circle</v-icon>
                                </v-layout>
                            </div>
                        </Draggable>
                    </Container>

                    <d-card-mini-editor v-if="newCard == section.id"
                        :key="section.id"
                        @ok="onAddCard"
                        @cancel="cancelAddCard"
                    ></d-card-mini-editor>

                    <div v-else
                         class="card-column-footer"
                         :key="section.id"
                         @click="newCardMode( section.id )"
                    >
                        <div class="column-status">
                            Всего карточек: {{ section.cards.length }}
                        </div>
                        <!--<div class="add-card">-->
                            <!--+ Добавить еще одну карточку-->
                        <!--</div>-->
                    </div>
                </div>

            </Draggable>

            <!--<v-btn v-if="board" class="kanban-btn-add-section" @click="onAddSection()">-->
                <!--+ Добавить еще одну колонку-->
            <!--</v-btn>-->

        </Container>

        <d-card-edit-dialog
            :editCard="editCard"
            ref="cardEditDialog"
            @ok="afterDialogCard"
        ></d-card-edit-dialog>

    </div>
</template>

<style>

    .start {
        background-color: #e3bcbc !important;
    }

    .finish {
        background-color: #b2d3bc !important;
    }

    .card-status {
        /*border: 1px solid #bdb5c4;*/
        border-radius: 3px;
        height: 22px;
        padding: 0 2px;
        width: 22px;
        /*cursor: default;*/
    }

    .card-status > i {
        color: #bdb5c4 !important;
        font-size: 16px;
    }

    .card-status.pool {
        border: 1px solid #bdb5c4;
    }

    .card-status.pool > i {
        color: #bdb5c4 !important;
    }

    .card-status.running {
        border: 1px solid #ff7043;
    }

    .card-status.running > i {
        color: #ff7043 !important;
    }

    .card-status.hold {
        border: 1px solid #26c6da;
    }

    .card-status.hold > i {
        color: #26c6da !important;
    }

    .card-status.finished {
        border: 1px solid #5db229;
    }

    .card-status.finished > i {
        color: #5db229 !important;
    }

    .card-status.canceled {
        border: 1px solid #ef5350;
    }

    .card-status.canceled > i {
        color: #ef5350 !important;
    }

</style>

<script>

  import { Container, Draggable } from 'vue-smooth-dnd'
  import DSectionMiniEditor from './DSectionMiniEditor'
  import DCardMiniEditor from './DCardMiniEditor'
  import uuidv4 from 'uuid/v4'
  import DCardEditDialog from "./DCardEditDialog"
  import { mapGetters } from 'vuex'
  import { uniq } from 'lodash'

  /**
   *
   *
   */
  const newSection = {
    sort: 1000,
    name: 'Новый список',
    description: null,
    cards: null,
    options: null
  }

  /**
   *
   *
   */
  const newCard = {
    sort: 1000,
    name: 'Новая карточка',
    description: null,
    options: null,
    deadline: null
  }

  /**
   *
   *
   */
  const CARD_STATUS = {

    pending: {
      class: '',
      icon: '',
      tooltip: 'Новая задача'
    },

    pool: {
      class: 'pool',
      icon: 'group',
      tooltip: 'Задача в пуле'
    },

    running: {
      class: '',
      icon: '',
      tooltip: 'Задача в работе'
    },

    hold: {
      class: 'hold',
      icon: 'mdi-snowflake', // pause
      tooltip: 'Задача приостановлена'
    },

    canceled: {
      class: 'canceled',
      icon: 'cancel',
      tooltip: 'Задача отменена'
    },

    finished: {
      class: 'finished',
      icon: 'done',
      tooltip: 'Задача выполнена'
    }
  }



  /**
   *
   *
   */
  export default {

    name: 'DKanban',

    componentName: "DKanban",

    components: {
      DCardEditDialog,
      DSectionMiniEditor,
      DCardMiniEditor,
      Container,
      Draggable
    },

    /**
     * Входящие данные компонента.
     *
     */
    props: {

      // Уровень доступа.
      access: {
        type: String,
        required: false,
        default: 'view',
        validator: function ( value ) {
          return [ 'view', 'edit' ].indexOf( value ) !== -1
        }
      },

      // Доска
      board: {
        type: Object,
        required: false,
        // default: null
      },

      // Список секций доски
      lists: {
        type: Array,
        required: false,
        // default: []
      },

      // Собственная должность
      post: {
        type: Object,
        required: false,
        default: null
      },
    },

    /**
     * Операционные данные компонента.
     *
     */
    data () {

      return {

        upperDropPlaceholderOptions: {
          className: 'cards-drop-preview',
          animationDuration: '150',
          showOnTop: true
        },

        dropPlaceholderOptions: {
          className: 'drop-preview',
          animationDuration: '150',
          showOnTop: true
        },

        sectionOptions: {
          orientation: 'vertical',
          className: 'card-container'
        },

        cardOptions: {
          className: 'kanban-card'
        },

        sectionMenu: [
          // { icon: 'add', title: 'Добавить карточку...', action: 'add' },

          // { title: 'Копировать список...' },
          // { title: 'Переместить список...' },
          // { divider: true },
          // { title: 'Сортировать по...' },
          // { divider: true },
          // { title: 'Переместить все карточки списка...' },
          { icon: 'delete', title: 'Удалить список', action: 'delete' },
        ],

        cardMenu: [
          { icon: 'info', title: 'Посмотреть карточку', action: 'view', access: ( card ) => { return true } },
          { icon: 'edit', title: 'Редактировать карточку', action: 'edit', access: ( card ) => { return this.cardEditAccess( card ) } },
          // { icon: 'delete', title: 'Удалить карточку', action: 'delete' },
        ],

        sections: [],

        sectionId: null,

        newCard: null,

        newCardText: '',

        editCard: null,

        cardStatus: CARD_STATUS
      }
    },

    /**
     *
     *
     */
    computed: {
      ...mapGetters( 'app/org', [ 'getPostById' ] ),
    },

    /**
     *
     *
     */
    watch: {

      lists: {

        handler( lists ) {

          this.sections = [...lists]
          this.loadPosts()
        },

        // Необходимо для инициализации значения по умолчанию
        immediate: true
      }
    },

    /**
     *
     *
     */
    created() {

      this.init()
    },

    /**
     *
     *
     */
    methods: {

      /**
       *
       *
       */
      init() {

        // console.log( `Обновление списков карточек` )
        // this.loadPosts()
      },

      /**
       * Проверка разрешения редактирования доски.
       *
       */
      isEditMode() {
        return this.access === 'edit'
      },

      /**
       *
       *
       */
      getColor( section ) {

        if ( section && section.options ) {

          return section.options.type === 'start'
            ? 'start'
            : 'finish'
        }

        return ''
      },

      /**
       *
       *
       */
      isStartSection( section ) {
        return section && section.options && section.options.type === 'start'
      },

      /**
       *
       *
       */
      isUserSection( section ) {
        return !section.options || [ 'start', 'finish' ].indexOf( section.options.type ) === -1
      },

      /**
       *
       *
       */
      isFinishSection( section ) {
        return section && section.options && section.options.type === 'finish'
      },

      /**
       *
       *
       */
      getStatusClass( card ) {

        if ( !card.process || !card.process.status_name ) {
          return null
        }

        return this.cardStatus[ card.process.status_name ].class
      },

      /**
       *
       *
       */
      getCardIcon( card ) {

        if ( !card.process || !card.process.status_name ) {
          return null
        }

        return this.cardStatus[ card.process.status_name ].icon
      },

      /**
       *
       *
       */
      getCustomersIds() {

        let customers = []

        this.sections.forEach( section => {
          section.cards.map( card => {
            if ( card.process ) {
              customers.push( card.process.customer_id )
            }
          } )
        } )

        return uniq( customers )
      },

      /**
       *
       *
       */
      loadPosts() {

        // Получение информации о сотудниках (ФИО и должность), запустившем процесс.
        this.$store.dispatch( 'app/org/entitiesInfo', { posts: this.getCustomersIds(), containers: [] } ).then( response => {

          // Добавление в хранилище информации о сотрудниках.
          this.$store.commit( 'app/org/addPosts', response.posts_data )

          //
          this.sections.forEach( section => {
            section.cards.map( card => {
              this.setCardCustomer( card )
            } )
          } )
        } )
      },

      /**
       *
       *
       */
      setCardCustomer( card ) {

        let post = card.process
          ? this.getPostById( card.process.customer_id )
          : null

        this.$set( card, 'customer', {
          photo: post ? this.getAccountPhotoUrl( post.photo ) : null,
          name: post ? `Заказчик: ${post.fullname} (${post.name})` : 'Заказчик не определен'
        } )
      },

      /**
       *
       *
       */
      getCustomerName( card ) {
        return ( card && card.customer ) ? card.customer.name : null
      },

      /**
       *
       *
       */
      getCustomerAvatar( card ) {
        return ( card && card.customer ) ? card.customer.photo : null
      },

      /**
       * Получение ссылки на фото пользователя.
       *
       * @param photo
       * @returns {*}
       */
      getAccountPhotoUrl( photo ) {
        return '/disk/d/' + photo
      },

      /**
       *
       *
       */
      getStatusTooltip( card ) {

        if ( !card.process || !card.process.status_name ) {
          return null
        }

        return this.cardStatus[ card.process.status_name ].tooltip
      },

      /**
       *
       *
       */
      sectionMenuHandler( action, id ) {

        if ( action === 'add' ) {
          this.newCardMode( id )
        }
        else if ( action === 'delete' ) {
          this.onDeleteSection( id )
        }

        return
      },

      /**
       *
       *
       */
      cardMenuHandler( action, sectionId, card ) {

        if ( action === 'edit' ) {
          this.dialogCard( card )
        }
        else if ( action === 'delete' ) {
          this.onDeleteCard( sectionId, card.id )
        }
        else if ( action === 'view' ) {
          this.$emit( 'openCard', card )
        }

        return
      },

      /**
       *
       *
       */
      dialogCard( card ) {

        this.$emit( 'changeCardData', card )

        // this.editCard = card
        // this.$nextTick( () => {
        //   this.$refs.cardEditDialog.show()
        // } )
      },

      /**
       *
       *
       */
      afterDialogCard( card ) {
        this.$emit( 'changeCard', card )
      },

      /**
       *
       *
       */
      onDeleteSection( sectionId ) {

        // Удаление списка с карточками запрещено.
        if ( !this.isSectionEmpty( sectionId ) ) {
          this.$dmsInfoNoty( 'Нельзя удалить список, в котором есть карточки. Сначала перенесите все карточки из списка.' )
          return
        }

        this.$dmsAgree( { title: 'Удаление списка', message: 'Вы уверены, что хотите удалить выбранный список?' } ).then( () => {

          this.$emit( 'deleteSection', sectionId )
        } ).catch( () => {} )
      },

      /**
       *
       *
       */
      onDeleteCard( sectionId, id ) {
        this.$emit( 'deleteCard', sectionId, id )
      },

      /**
       *
       *
       */
      getBlankCard() {

        let card = Object.assign( {}, newCard )
        card.id = uuidv4()
        card.board_id = this.board.id

        return card
      },

      /**
       *
       *
       */
      onAddCard( name ) {

        const section = this.getSection( this.newCard )

        if ( section ) {

          let card = this.getBlankCard()

          card.section_id = this.newCard
          card.name = name
          card.sort = this.getSortIndex( section.cards, section.cards.length )

          this.$emit( 'addCard', card )
          this.newCardText = ''
          this.newCard = null
        }
      },

      /**
       *
       *
       */
      getBlankSection() {

        let section = Object.assign( {}, newSection )
        section.id = uuidv4()
        section.board_id = this.board.id
        section.cards = []
        section.sort = this.getSortIndex( this.sections, this.sections.length)

        return section
      },

      /**
       *
       *
       */
      onAddSection() {

        let section = this.getBlankSection()
        this.$emit( 'addSection', section )
      },

      /**
       *
       *
       */
      onChangeSection( section ) {

        this.sectionId = null
        this.$emit( 'changeSection', section )
      },

      /**
       * Добавление карточки.
       *
       */
      addCard( card ) {

        this.sections.forEach( ( section ) => {

          if ( section.id === card.section_id ) {

            this.setCardCustomer( card )
            section.cards.push( card )
          }
        } )
      },

      /**
       * Добавление списка.
       *
       * @param section
       */
      addSection( section ) {

        console.log( section )

        this.sections.push( section )
      },

      /**
       * Удаление списка.
       *
       */
      deleteSection( id ) {

        const index = this.getSectionIndex( id )

        if ( index !== null ) {
          this.sections.splice( index, 1 )[ 0 ]
        }
      },

      /**
       * Изменение карточки.
       *
       */
      changeCard( card ) {

        const sectionIndex = this.getSectionIndex( card.section_id )
        const cardIndex = this.getCardIndex( card.section_id, card.id )

        this.setCardCustomer( card )

        if ( sectionIndex !== null && cardIndex !== null ) {
          this.$set( this.sections[ sectionIndex ].cards, cardIndex, card )
        }
      },

      /**
       * Удаление карточки.
       *
       */
      deleteCard( sectionId, id ) {

        const section = this.getSection( sectionId )
        const index = this.getCardIndex( sectionId, id )

        if ( section && index !== null ) {
          section.cards.splice( index, 1 )[ 0 ]
        }
      },

      /**
       *
       *
       * @param columnId
       */
      newCardMode( columnId ) {
        // console.log('addCard')
        // this.newCard = columnId
      },

      /**
       *
       *
       */
      cancelAddCard() {
        this.newCard = null
      },

      /**
       *
       *
       */
      sectionNameMode( sectionId ) {

        if ( this.isEditMode() ) {
          this.sectionId = sectionId
        }
      },

      /**
       *
       *
       */
      cancelSectionNameMode() {
        this.sectionId = null
      },


      /**
       *
       *
       */
      onColumnDrop( dropResult ) {

        let sections = this.sections.map( a => ( {...a} ) )
        sections = this.applyDrag( sections, dropResult, 'changeSection' )
        this.sections = sections
      },

      /**
       *
       *
       */
      onCardDrop( columnId, dropResult ) {

        if ( dropResult.removedIndex !== null || dropResult.addedIndex !== null ) {

          let sections = this.sections.map( a => ( {...a} ) )
          const column = sections.filter( p => p.id === columnId )[ 0 ]
          const columnIndex = sections.indexOf( column )
          const newColumn = Object.assign( {}, column )

          newColumn.cards = this.applyDrag( newColumn.cards, dropResult, 'changeCard', columnId )
          this.sections.splice( columnIndex, 1, newColumn )
        }
      },

      /**
       *
       *
       */
      getSectionPayload( index ) {
        return this.sections[ index ]
      },

      /**
       *
       *
       */
      getCardPayload( columnId ) {
        return index => {
          return this.sections.filter( p => p.id === columnId )[ 0 ].cards[ index ]
        }
      },


      dragStart() {
        // console.log('drag started')
      },


      log(...params) {
        // console.log(...params)
      },

      /**
       *
       *
       */
      applyDrag( list, dragResult, eventType, sectionId = null ) {

        const { removedIndex, addedIndex, payload } = dragResult

        if ( removedIndex === null && addedIndex === null ) return list

        const result = [...list]
        let itemToAdd = payload

        // Если идет обработка списка источника:
        if ( removedIndex !== null ) {
          // Удаление карточки из списка (откуда перемещается карточка).
          itemToAdd = result.splice( removedIndex, 1 )[ 0 ]
        }

        // Если идет обработка списка приемника:
        if ( addedIndex !== null ) {

          if ( typeof itemToAdd === 'object' ) {

            itemToAdd.section_id = sectionId
            itemToAdd.sort = this.getSortIndex( result, addedIndex )

            this.$emit( eventType, itemToAdd )
          }

          // Добавление карточки в список (куда перемещается карточка).
          result.splice( addedIndex, 0, itemToAdd )
        }

        // Возвращается обработанный список (источник или приемник).
        return result
      },

      /**
       * Получение индекса сортировки.
       *
       * @param list
       * @param index
       * @returns {number}
       */
      getSortIndex( list, index ) {

        const step = 1000

        if ( !Array.isArray( list ) ) {
          console.error( 'Для расчета индекса сортировки требуется массив' )
          return 0
        }

        if ( list.length === 0 ) {
          return step
        }

        if ( index === 0 ) {
          return Number( list[ 0 ].sort ) / 2
        }

        if ( index === list.length ) {
          return Number( list[ list.length - 1 ].sort ) + step
        }

        return ( Number( list[ index - 1 ].sort ) + Number( list[ index ].sort ) ) / 2
      },

      /**
       * Получение индекса списка.
       *
       * @param id
       * @returns {any}
       */
      getSectionIndex( id ) {

        const index = this.sections.findIndex( section => section.id === id )

        return index !== -1 ? index : null
      },

      /**
       * Получение списка.
       *
       * @param id
       * @returns {*}
       */
      getSection( id ) {
        return this.sections.find( section => section.id === id )
      },

      /**
       * Проверка, отсутствуют ли в списке карточки.
       *
       */
      isSectionEmpty( id ) {

        let section = this.getSection( id )

        if ( section ) {
          return section.cards.length === 0
        }

        return false
      },

      /**
       * Получение индекса карточки.
       *
       */
      getCardIndex( sectionId, id ) {

        let section = this.getSection( sectionId )

        if ( !section ) {
          return null
        }

        const index = section.cards.findIndex( card => card.id === id )

        return index !== -1 ? index : null
      },

      /**
       * Получение карточки.
       *
       * @param sectionId
       * @param id
       * @returns {*}
       */
      getCard( sectionId, id ) {

        let section = this.getSection( sectionId )

        return section ? section.cards.find( card => card.id === id ) : null
      },

      /**
       *
       *
       */
      findCardByProcessId( processId ) {

        let foundCard = null

        this.sections.map( section => {
          section.cards.map( card => {
            if ( card.process && card.process.id === processId ) {
              foundCard = card
            }
          } )
        } )

        return foundCard
      },

      /**
       *
       *
       */
      deleteCardByProcessId( processId ) {

        let card = this.findCardByProcessId( processId )

        if ( card ) {
          this.deleteCard( card.section_id, card.id )
        }
      },

      /**
       * Контроль перемещения списков.
       *
       * @param src
       * @param payload
       * @returns {boolean}
       */
      sectionDropControl( src, payload ) {

        if ( src.groupName === 'card' ) {
          return false
        }

        // Перемещение списков разрешено только в режиме редактирования доски.
        if ( !this.isEditMode() ) {
          return false
        }

        // Ограничений нет.
        return true
      },

      /**
       * Контроль перемещения карточек.
       *
       * @param section
       * @param src
       * @param payload
       * @returns {boolean}
       */
      cardDropControl ( src, payload, section ) {

        if ( src.groupName === 'section' ) {
          return false
        }

        // // Если перемещается список, ограничений нет.
        // if ( !payload || !payload.process ) {
        //   return true
        // }

        let status = payload.process.status_name
        let executorId = payload.process.contractor_id
        let card = payload

        // Перемещение карточки нового процесса
        // разрешено только по пользовательским спискам.
        if ( ( status === 'pending' || status === 'pool' ) && this.isFinishSection( section ) ) {
          return false
        }

        // Перемещение карточки завершенного или отмененного процесса
        // разрешено только внутри списка закрытых задач.
        if ( ( status === 'finished' || status === 'canceled' ) && card.section_id !== section.id ) {
          return false
        }

        // Перемещение карточки приостановленного процесса
        // разрешено только по пользовательским спискам.
        if ( status === 'hold' && !this.isUserSection( section ) ) {
          return false
        }

        // Перемещение карточек в список новых процессов запрещено.
        if ( this.isStartSection( section ) && card.section_id !== section.id ) {
          return false
        }

        // Перемещение карточек другого исполнителя запрещено.
        if ( executorId !== this.post.id ) {
          return false
        }

        // Ограничений нет.
        return true
      },

      /**
       * Получение цвета для карточки.
       *
       * Белый - собственная задача
       * Зеленый - задача для другого сотрудника
       * Красный - задача от другого сотрудника
       *
       * @param card
       * @returns {*}
       */
      getColorByProcessType( card ) {

        if ( !card || !card.process ) {
          return null
        }

        if ( card.process.customer_id === card.process.contractor_id ) {
          return 'background: #fff;'
        }
        else if ( card.process.customer_id === this.post.id ) {
          return 'background: #d8ffec;'
        }
        else {
          return 'background: #fdd;'
        }
      },

      /**
       *
       *
       */
      isCardExecutor( card ) {

      },

      /**
       *
       *
       */
      isCardManager( card ) {

      },

      /**
       *
       *
       * @param card
       * @returns {boolean}
       */
      cardEditAccess( card ) {

        if ( card && card.process && card.process.process_model ) {

          if ( card.process.status === 40 || card.process.status === 30 ) {
            return false
          }

          if ( card.process.customer_id === card.process.contractor_id ) {
            return card.process.process_model.type === 10
          }
          else if ( card.process.customer_id === this.post.id ) {
            return card.process.process_model.type === 10
          }
          else {
            return false
          }
        }

        return false
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/DKanban/src/DKanban.vue